import { useAppData } from "@/hooks/global-hooks/AppDataContext";
import React, { useEffect, useRef } from "react";

// Utilitaire simple pour crypter/décrypter (base64, à remplacer par mieux si besoin)
function encrypt(data) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(data))));
}
function decrypt(data) {
  try {
    return JSON.parse(decodeURIComponent(escape(atob(data))));
  } catch {
    return null;
  }
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function setCookie(name, value, hours = 24) {
  const expires = new Date(Date.now() + hours * 3600 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

const COOKIE_NAME = "kubrik_currencies";

const getCurrencySymbolFromCode = (code) => {
  // Utilise le contexte pour récupérer la liste des devises
  const { currencies, loadingCurrencies, errorCurrencies } = useAppData();
  if (!currencies || currencies.length === 0) {
    return null;
  }
  const currency = currencies.find((currency) => currency.code === code);
  if (!currency) {
    console.warn(`Currency code ${code} not found`);
    return null;
  }
  return currency.symbol;
};

export default getCurrencySymbolFromCode;
